import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=out, obj=in
  const [token, setToken] = useState(localStorage.getItem("hm_token"));

  useEffect(() => {
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("hm_token");
        setToken(null);
        setAdmin(false);
      });
  }, [token]);

  const login = (accessToken, user) => {
    localStorage.setItem("hm_token", accessToken);
    setToken(accessToken);
    setAdmin(user);
  };

  const logout = () => {
    localStorage.removeItem("hm_token");
    setToken(null);
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
